// extracted by mini-css-extract-plugin
export var wrapper = "v_b";
export var inputsGroup = "v_bT";
export var submit = "v_bV";
export var submitCaption = "v_bW";
export var success = "v_bX";
export var error = "v_bY";